module.exports = __webpack_public_path__ + "static/project-9c-6afa07a5f703395aa2e4fb71391c7799.png";